<script lang="ts">
  import { Link, Tooltip } from 'carbon-components-svelte';
  import Information16 from 'carbon-icons-svelte/lib/Information16';

  type TooltipListItem = string | { label: string; href?: string };

  export let items: TooltipListItem[] = [],
    triggerText = '',
    title = '',
    icon = Information16,
    direction: 'top' | 'right' | 'bottom' | 'left' = 'right',
    align: 'start' | 'center' | 'end' = 'center';

  function normalize(item: TooltipListItem): { label: string; href?: string } {
    return typeof item === 'string' ? { label: item } : item;
  }

  function onLinkClick(event: MouseEvent, href?: string): void {
    if (!href) {
      return;
    }

    event.preventDefault();
    window.open(href, '_blank', 'noopener');
  }

  $: normalizedItems = items.map(normalize);
</script>

<div class="tooltip">
  <Tooltip {triggerText} {icon} {direction} {align} portalTooltip>
    {#if title}
      <p class="title">{title}</p>
    {/if}
    <ul class="list">
      {#each normalizedItems as item}
        <li>
          {#if item.href}
            <Link inline href={item.href} on:click={(event) => onLinkClick(event, item.href)}>{item.label}</Link>
          {:else}
            {item.label}
          {/if}
        </li>
      {/each}
    </ul>
  </Tooltip>
</div>

<style>
  .tooltip :global(.bx--tooltip__label) {
    font-size: unset;
    gap: 0.5rem;
  }

  .tooltip :global(.bx--tooltip__label .bx--tooltip__trigger) {
    margin-left: unset;
  }

  .title {
    margin: 0 0 0.5rem;
    font-weight: 600;
  }

  .list li + li {
    margin-top: 0.25rem;
  }
</style>
